// extracted by mini-css-extract-plugin
module.exports = {"navWrapper":"header_navWrapper__H5syM","navLink":"header_navLink__GDpGH","active":"header_active__o_qs3"};